// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { getType } from 'typesafe-actions';
import { ProductCard } from '../../components/NewCard/types';
import { PaginationListResponse } from '../../types/Model';
import { KeywordTitle } from '../actionCreators/search/searchOnlineCoursesKeywordActions';

import { RootAction, actionCreatorsList } from '../rootActionCreator';

export interface SearchOnlineCoursesState {
  onlineCoursesListData: PaginationListResponse<ProductCard>;
  onlineCoursesKeyword: { [key: string]: KeywordTitle[] };
  isFetching: boolean;
  isFetchingMore: boolean;
  isKeywordFetching: boolean;
  error?: Error;
  keywordError?: Error;
}

const {
  searchOnlineCoursesActions,
  searchOnlineCoursesKeywordActions
} = actionCreatorsList;

export const initialSearchOnlineCoursesState: SearchOnlineCoursesState = {
  onlineCoursesListData: {
    list: [],
    totalPage: 0,
    count: 0,
    page: 0,
    limit: 0,
  },
  onlineCoursesKeyword: {},
  isFetching: true,
  isFetchingMore: false,
  isKeywordFetching: true
};

export default function (state = initialSearchOnlineCoursesState, action: RootAction): SearchOnlineCoursesState {
  switch (action.type) {
    /** searchOnlineCoursesActions will trigger when new condition is given */
    case getType(searchOnlineCoursesActions.request): {
      return {
        ...state,
        isFetching: true,
        isFetchingMore: action.payload.page > 1,
        error: undefined,
      };
    }
    case getType(searchOnlineCoursesActions.success): {
      const {
        list,
        totalPage,
        count,
        page,
        limit,
      } = action.payload;

      const nextList = page === 1 ? list : [...state.onlineCoursesListData.list, ...list];
      return {
        ...state,
        isFetching: false,
        isFetchingMore: false,
        onlineCoursesListData: {
          list: nextList,
          totalPage,
          count,
          page,
          limit,
        },
      };
    }
    case getType(searchOnlineCoursesActions.failure): {
      return {
        ...state,
        isFetching: false,
        isFetchingMore: false,
        error: action.payload.error
      };
    }
    case getType(searchOnlineCoursesKeywordActions.request): {
      return {
        ...state,
        isKeywordFetching: true,
        keywordError: undefined
      };
    }
    case getType(searchOnlineCoursesKeywordActions.success): {
      const { name = '', list, count } = action.payload;
      const nextOnlineCoursesKeyword = state.onlineCoursesKeyword;
      nextOnlineCoursesKeyword[name] = list;
      return {
        ...state,
        isKeywordFetching: false,
        onlineCoursesKeyword: nextOnlineCoursesKeyword
      };
    }
    case getType(searchOnlineCoursesKeywordActions.failure): {
      return {
        ...state,
        isKeywordFetching: false,
        keywordError: action.payload.error
      };
    }

    default: {
      return state;
    }
  }
}
